import React from "react";

import Applet from "../../Applet";
import DocumentTypeFormTable from "../../../../components/IntegrationTemplate/DocumentTypeFormTable";

class DocumentTypeFormTableApplet extends Applet {

    render() {
        return <DocumentTypeFormTable applet={this}
                               pageSize={this.state.PageSize}
                               placement={this.state.Placement}
                               columns={this.state.Columns}
                               title="Document Type Forms"
                               enterpriseComponent={this.getEnterpriseComponent()}
                               sort={this.state.Sort}
                               menu={this.state.Menu}
                               rowHeight={this.state.RowHeight}
                               enableSort={true}
                               enableDefaultSort={false}
        />;
    }

    state = {
        Name: "DocumentTypeFormTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 20,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 20,
            "lx": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "FormDocumentRevisionDocumentIDPlusRevision",
                },
                {
                    id: "FormDocumentRevisionStatus",
                },
                {
                    id: "FormDocumentRevisionUSID",
                },
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "FormDocumentRevisionDocumentIDPlusRevision",
                width: 200,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "ID",
            },
            {
                id: "FormDocumentRevisionStatus",
                width: 150,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Status",
            },
            {
                id: "FormDocumentRevisionUSID",
                width: 300,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Document Revision USID",
            }
        ],
    };
}

export default DocumentTypeFormTableApplet;
